export const FEATURES = {
  FEE_COLLECTION: 'fee_collection',
  ATTENDANCE: 'attendance',
  BIOMETRIC_SYNC: 'biometric_sync',
  PERFORMANCE: 'performance',
  EXAM_BOARDS: 'exam_boards',
  PARENT_COMMUNICATION: 'parent_communication',
  REFERRALS: 'referrals',
  WHITE_LABEL: 'white_label',
  SOCIAL_LOGIN: 'social_login',
  TEACHER_ACCOUNTS: 'teacher_accounts',
  EMAIL_CUSTOMISATION: 'email_customisation',
  REPORTING: 'reporting',
  WHATSAPP_NOTIFICATIONS: 'whatsapp_notifications',
  // SMS was dropped with the move off MSG91. The notification_channel DB enum
  // retains its 'sms' value (removing an enum value is disruptive), but there is
  // no SMS feature flag or channel.
} as const

export type FeatureKey = (typeof FEATURES)[keyof typeof FEATURES]

export const ALL_FEATURE_KEYS: readonly FeatureKey[] = Object.values(FEATURES)

export type FeatureMap = Partial<Record<FeatureKey, boolean>>
